import styles from "./Hero.module.css";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className={styles.hero}>
      <div className={styles.overlay}></div>

      <motion.div
        className={styles.content}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <span className={styles.badge}>ERP 100% Web</span>

        <h1 className={styles.title}>
          <span className={styles.highlight}>MBControl ERP</span>
          <br />
          Gestao completa para sua empresa
        </h1>

        <p className={styles.subtitle}>
          Do PDV a nota fiscal, do estoque ao financeiro. Um sistema integrado,
          moderno e acessivel de qualquer lugar.
        </p>

        <div className={styles.actions}>
          <a
            href="#produtos"
            className={styles.buttonPrimary}
          >
            Conhecer o MBControl
          </a>
          <a
            href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20conhecer%20o%20MBControl"
            target="_blank"
            rel="noreferrer"
            className={styles.buttonSecondary}
          >
            Falar no WhatsApp
          </a>
        </div>
      </motion.div>
    </section>
  );
}
